import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import keys from './keys';
import { FormattedMessage } from 'react-intl';
import useMessage from '../../../hooks/useMessage';
import useApiMutation from '../useApiMutation';

const useSetMe = () => {
  const { message } = useMessage();
  const queryClient = useQueryClient();

  const mutation = useApiMutation({
    getRequestUrl: () => '/me',
    method: 'PATCH',
    onSuccess: (newUserData) => {
      queryClient.setQueryData(keys.me, newUserData);
    },
    onError: () => {
      message.danger({
        content: (
          <FormattedMessage defaultMessage="There was an error while updating your profile." />
        ),
      });
    },
  });

  return {
    setUser: mutation.mutate,
    isSetUserLoading: mutation.isLoading,
    isSetUserError: mutation.isError,
    isSetUserSuccess: mutation.isSuccess,
    ...mutation,
  };
};

export default useSetMe;
